// ============================================
// モジュール読み込み
// ============================================
import { loadingFin, resizeCheck,hamburger,openModal,tabSwitch, mvAnime,scrollHint,countUp,setUpAccordion,stickySidebar,hashLinkSmoothScroll,headerScrollAnim,mouseDrag} from "./libs/common";
import { viewport } from "./libs/viewport";
import { io } from "./libs/intersectionOvserver";
import initSplide from './libs/splide';

// openNav();
loadingFin();
resizeCheck();
viewport();
io();
hamburger();
tabSwitch();
openModal();
initSplide();
mvAnime();
scrollHint();
countUp();
setUpAccordion();
stickySidebar();
hashLinkSmoothScroll();
headerScrollAnim();
mouseDrag('.js-dragScroll');

